(() => {
  const sections = document.querySelectorAll('.cbs-collection');

  sections.forEach((section) => {
    const panel = section.querySelector('[data-cbs-filter-panel]');
    const openBtn = section.querySelector('[data-cbs-filter-open]');
    const closeBtns = section.querySelectorAll('[data-cbs-filter-close]');
    const backdrop = section.querySelector('.cbs-filter-backdrop');
    const sort = section.querySelector('[data-cbs-sort]');
    const facetForm = section.querySelector('.cbs-facets-form');
    const productArea = section.querySelector('.cbs-products');
    const viewButtons = section.querySelectorAll('[data-cbs-view]');

    const openFilters = () => {
      if (!panel) return;
      panel.classList.add('is-open');
      backdrop?.classList.add('is-open');
      openBtn?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('cbs-filters-open');
    };

    const closeFilters = () => {
      if (!panel) return;
      panel.classList.remove('is-open');
      backdrop?.classList.remove('is-open');
      openBtn?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('cbs-filters-open');
    };


    const setView = (view) => {
      if (!productArea || !viewButtons.length) return;
      productArea.classList.toggle('is-list', view === 'list');
      viewButtons.forEach((button) => {
        const active = button.dataset.cbsView === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { sessionStorage.setItem('cbs-collection-view', view); } catch (_) {}
    };

    if (viewButtons.length) {
      let savedView = 'grid';
      try { savedView = sessionStorage.getItem('cbs-collection-view') || 'grid'; } catch (_) {}
      setView(savedView);
      viewButtons.forEach((button) => {
        button.addEventListener('click', () => setView(button.dataset.cbsView));
      });
    }

    openBtn?.addEventListener('click', openFilters);
    closeBtns.forEach((button) => button.addEventListener('click', closeFilters));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeFilters();
    });

    sort?.addEventListener('change', () => {
      sort.form?.submit();
    });

    // Desktop: submit filters immediately.
    // Mobile/tablet: users can make multiple selections and tap "View Results".
    facetForm?.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (window.matchMedia('(min-width: 1101px)').matches) {
          facetForm.submit();
        }
      });
    });

    // Product card — wishlist heart (same behavior as the homepage card).
    let savedWishlist = [];
    try { savedWishlist = JSON.parse(localStorage.getItem('cbs-wishlist') || '[]'); } catch (_) {}
    section.querySelectorAll('[data-wishlist]').forEach((button) => {
      const handle = button.dataset.wishlist;
      const sync = () => {
        const active = savedWishlist.includes(handle);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      };
      sync();
      button.addEventListener('click', () => {
        savedWishlist = savedWishlist.includes(handle)
          ? savedWishlist.filter((item) => item !== handle)
          : [...savedWishlist, handle];
        try { localStorage.setItem('cbs-wishlist', JSON.stringify(savedWishlist)); } catch (_) {}
        sync();
      });
    });

    // Product card — quick add to cart (same behavior as the homepage card).
    section.querySelectorAll('[data-quick-add-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button');
        const label = button.querySelector('span');
        const message = form.querySelector('.cbs-card__message');
        const original = label.textContent;
        button.disabled = true;
        label.textContent = form.dataset.addingLabel || 'Adding…';
        message.textContent = '';
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form),
          });
          if (!response.ok) {
            const errJson = await response.json().catch(() => null);
            throw new Error((errJson && errJson.message) || 'Unable to add');
          }
          await response.json();
          const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await cartResponse.json();
          label.textContent = form.dataset.addedLabel || 'Added!';
          message.textContent = form.dataset.addedMessage || 'Added to your cart.';
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: form.getAttribute('id'), data: { itemCount: cart.item_count, source: 'cbs-main-collection' } },
            })
          );
          setTimeout(() => {
            label.textContent = original;
            message.textContent = '';
          }, 1800);
        } catch (_) {
          label.textContent = original;
          message.textContent = form.dataset.errorMessage || 'Please try again.';
        } finally {
          button.disabled = false;
        }
      });
    });
  });
})();

if (!window.CBSQuickViewCartBridge) {
  window.CBSQuickViewCartBridge = true;
  document.addEventListener('cbs:cart:updated', async () => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'cbs-quick-view', data: { itemCount: cart.item_count, source: 'cbs-quick-view' } },
        })
      );
    } catch (_) {}
  });
}
